<template lang="pug">
    .user.box
        .title 用户中心
        hr
        //- 默认显示
        .user-item(v-if="!changing && USER.CELLPHONE")
            .item-title
                i.el-icon-phone
                | &nbsp;手机号码：
            span.grow {{USER.CELLPHONE}}
            el-button(@click="changing = !changing") 解除绑定
        div(v-else)
            .user-item
                el-input(v-model="phone", prefix-icon="el-icon-phone", autocomplete="off", placeholder="请输入手机号码", size="large")
            .user-item
                el-input(type="password", v-model="sms", autocomplete="off", prefix-icon="el-icon-chat-line-square", placeholder="请输入验证码" :loading="sendSmsLoading")
                    el-button(slot="append" @click="sendSms") {{ time || '发送验证码'}}
            .user-item.jr
                el-button(v-if="unbind" type="danger" @click="submit" :loading="loading") 解除绑定
                el-button(v-else type="primary" @click="submit" :loading="loading") 绑定手机
                el-button(@click="changing = !changing") 取消
</template>

<script>
import storeMixin from '../store/mixin';

export default {
    mixins: [storeMixin],

    name: 'User',
    data() {
        return {
            changing: false,
            phone: '',
            sms: '',
            sendSmsLoading: false,
            loading: false,
            time: 0,
            timer: null,
            redirectUrl: '/',
        };
    },
    created() {
        console.log(this.USER);
    },
    methods: {
        sendSms() {
            if (this.time || this.sendSmsLoading) {
                return;
            }
            if (this.phoneError) {
                this.$message.error(this.phoneError);
            } else {
                this.sendSmsLoading = true;
                this.cooling();
                this.REQUEST({
                    url: 'v2/user/sms/code/send',
                    method: 'POST',
                    data: {
                        phone_number: this.phone,
                        sms_type: this.smsType,
                    },
                })
                    .then(data => {
                        this.$message.success('发送成功');
                        this.sendSmsLoading = false;
                    })
                    .catch(e => {
                        this.sendSmsLoading = false;
                    });
            }
        },
        cooling() {
            this.time = 60;
            this.timer = window.setInterval(() => {
                if (this.time > 0) {
                    this.time--;
                } else {
                    clearInterval(this.timer);
                }
            }, 1000);
        },
        submit() {
            if (this.phoneError) {
                this.$message.error(this.phoneError);
            } else if (this.smsError) {
                this.$message.error(this.smsError);
            } else {
                this.loading = true;
                const data = this.unbind
                    ? {
                          code: this.sms,
                      }
                    : {
                          phone_number: this.phone,
                          sms_type: this.smsType,
                          code: this.sms,
                      };

                this.REQUEST({
                    method: 'POST',
                    url: this.submitUrl,
                    data,
                })
                    .then(data => {
                        if (data.code != 0) {
                            this.$message.warning(
                                data.message || '操作失败，请稍候再试。'
                            );
                            this.loading = false;
                            this.sms = '';
                            return;
                        }
                        const msg = this.unbind ? '解绑成功' : '绑定成功';
                        if (this.unbind) {
                            this['USER/SET_STATE']({
                                key: 'CELLPHONE',
                                value: null,
                            });
                        } else {
                            this['USER/SET_STATE']({
                                key: 'CELLPHONE',
                                value: this.phone.replace(
                                    /(\d{3})\d{4}(\d{4})/,
                                    (_, $1, $2) => `${$1}****${$2}`
                                ),
                            });
                        }
                        this.$message.success(msg);
                        this.loading = false;
                        this.changing = false;
                        this.phone = '';
                        this.sms = '';

                        // setTimeout(() => {
                        //     location.href = '';
                        // }, 1000);
                        // return;
                    })
                    .catch(e => {
                        this.loading = false;
                    });
            }
        },
    },
    computed: {
        unbind() {
            return this.changing && this.USER.CELLPHONE;
        },
        smsType() {
            return this.unbind ? 'unbind_phone' : 'bind_phone';
        },
        submitUrl() {
            return `v2/user/${this.unbind ? 'unbind' : 'bind'}/phone`;
        },
        phoneError() {
            if (!this.phone) {
                return '手机号码不能为空';
            } else if (!/^1[3456789]\d{9}$/.test(this.phone)) {
                return '手机号码格式有误';
            }
            return '';
        },
        smsError() {
            if (!this.sms) {
                return '验证码不能为空';
            }
            return '';
        },
    },
};
</script>

<style lang="stylus" scoped>
.user
    width 1000px
    margin 0 auto
.user-item
    max-width 400px
    margin 0 auto 20px auto
    display flex
    align-items center
    gap 10px
    &.jr
        justify-content right
.item-title
    white-space nowrap
.grow
    flex-grow 1
.title
    display flex
    align-items center
    font-size 1.2em
    margin-bottom 10px
    i
        margin-right 10px
hr
    border-color rgba(255,255,255,.1)
    margin-bottom 50px
</style>
